import { render, staticRenderFns } from "./EnglishPlayBox.vue?vue&type=template&id=e1a48ce6"
import script from "./EnglishPlayBox.vue?vue&type=script&lang=js"
export * from "./EnglishPlayBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports